import React, { useState } from 'react'
import { Form, Table } from 'react-bootstrap'
import { FetchCreateTransaction, FetchCreateTransactionDraft, FetchUpdateTransactionDraft } from '../../../fetcher'
import '../../../index.css'
import { ModalView } from '../../_reusedcomponents/ModalView'
import AlertMessage from '../../alertmessages/AlertMessageView'
import { TransactionOrderView } from './TransactionOrderView'
import { useHandleAlertMessage } from '../../../utils/togglinghooks'

const CreateTransactionListView = ({ removeOrderEntry, transactionOrder, remark, resetOrderEntries, handleCloseMask, reloadParent, isDraftUpdate = false, draftSysId = null }) => {
    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    /**
     * Sets a modals visibility
    */
    const OpenModal = () => {
        return (
            handleShow()
        )
    }

    const [hasInvalidArticles, setHasInvalidArticles] = useState(false)

    /**
     * Submits a transaction of type delivery. Calls Fetch API.
     * Creates a transaction or turns a draft into complete transaction.
    */
    const submitDelivery = () => {
        const transactionToCreate = {
            TransactionType: "Delivery",
            SerializedArticleData: JSON.stringify(transactionOrder),
            Remark: remark,
            CreateTransactionFromDraft: isDraftUpdate,
        }
        isDraftUpdate ? /*-- do create Transaction from draft here --*/ FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries)
            : FetchCreateTransaction(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries)

        handleClose()
    }

    /**
     * Temporarily saves a transaction of type delivery. Calls Fetch API.
     * Creates a transaction draft or updates it.
    */
    const saveDelivery = () => {
        const transactionToCreate = {
            TransactionType: "Delivery",
            SerializedArticleData: JSON.stringify(transactionOrder),
            IsFAEXDelivery: false,
            BoutiqueSysId: null,
            Remark: remark,
            CreateTransactionFromDraft: false,
        }
        isDraftUpdate ? FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries)
            : FetchCreateTransactionDraft(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries)

        handleClose()
    }

    return (
        <div className="listtable table-width">
            <Form onSubmit={e => {
                e.preventDefault()
                OpenModal()
            }} id="delivery-order-submit">
                <Table striped hover aria-labelledby="tabelLabel" size="sm">
                    {transactionOrder.map(entry =>
                        <TransactionOrderView removeOrderEntry={removeOrderEntry} {...entry} isDeliveryOrder={true} setHasInvalidArticles={setHasInvalidArticles} />
                    )}
                </Table>
            </Form>

            <ModalView handleShow={show} handleClose={handleClose} handleSubmit={submitDelivery} isDraftModal={true} handleSave={saveDelivery}
                modalTitle={window.i18n('submitDelivery')}
                modalBody={window.i18n('submitDelivery3')}
                 />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

export { CreateTransactionListView }